// extracted by css-extract-rspack-plugin
export default {"operator":"operator_FITgi","title":"title_nAZNK"};